
// axios
import axios from "axios";
// option
import { ClientOption } from "../../../config/clientOption";

export const GetSettings = async () => {
    const { data: response } = await axios.get(`${process.env.REACT_APP_API_URL}settings`, ClientOption);
    return response.data;
}